import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private messageService: MessageService, private translate: TranslateService) {}

  success(message: string) {
    this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS'), detail: message });
  }

  info(message: string) {
    this.messageService.add({ severity: 'info', summary: this.translate.instant('INFO'), detail: message });
  }

  warn(message: string) {
    this.messageService.add({ severity: 'warn', summary: this.translate.instant('WARNING'), detail: message });
  }

  error(message: string) {
    this.messageService.add({ severity: 'error', summary: this.translate.instant('ERROR'), detail: message });
  }

  message(summary: string, message: string) {
    this.messageService.add({ severity: 'contrast', summary, detail: message });
  }
}
